var ctrlopt = ctrlopt,
  site = site || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var settings = Drupal.settings.globals_variables || {};
  var oab_year_suffix = settings.oab_year_suffix || '';
  var oab_month_suffix = settings.oab_month_suffix || '';
  var oab_day_suffix = settings.oab_day_suffix || '';
  var oab_postcode_override = settings.oab_postcode_override || 0;
  var oab_phone_override = settings.oab_phone_override || 0;
  var validate_password_enabled = Drupal.settings.validate_password_enabled || 0;
  var oab_date_format_with_dot = settings.oab_date_format_with_dot || 0;
  var oab_time_format_24h = settings.oab_time_format_24h || 0;
  var oab_phone_inline = settings.oab_phone_inline || 0;
  var validate_password_enabled = Drupal.settings.validate_password_enabled || 0;

  /* Concrete View */
  apptBook.myAppts = {
    init: function () {
      var curApptData,
        pastApptData,
        token,
        me = this,
        config = Drupal.settings.appointment_booking_main_collection,
        suppressLinks = false,
        container = $('#appointment-book-container'),
        apptCont = $('#account-my-appointments'),
        curAppts = $('#my-appointments-current'),
        pastAppts = $('#my-appointments-past'),
        viewPastBtn = curAppts.find('.accordion-appt-past'),
        viewMakeupLessons = $('#view-makeup-lessons-btn'),
        curApptTmpl = curAppts.find('.appointment-container').remove().first(),
        curApptTmplWrppr = curAppts.find('.js-appt-container'),
        pastApptTmpl = pastAppts.find('.appointment-container').remove().first(),
        pastApptTmplWrppr = pastAppts.find('.js-appt-container'),
        overlay = $('#appt-book-my-appointments-overlay'),
        closeBtn = overlay.find('.overlay-close'),
        overlayConf = overlay.find('#confirm-cancel'),
        overlayCanc = overlay.find('#appt-canceled'),
        yesBtn = overlayConf.find('.yes-btn'),
        noBtn = overlayConf.find('.no-btn'),
        noAppts = $('#appt-book-my-appointments-no-appts').remove(),
        noSignin = $('#appt-book-my-appointments-no-signin').remove(),
        months = apptCont.attr('data-month-names').split(','),
        phoneFormat = apptCont.attr('data-phone-format'),
        minLabel = apptCont.attr('data-minutes-label'),
        curSymbol = apptCont.attr('data-currency-symbol'),
        separator = apptCont.attr('data-services-separator'),
        legalCopy = container.find('.services-legal-copy'),
        atCopy = 'at',
        $bod = $('body'),
        isSignedIn = 0,
        totalDuration = 0,
        geoLocEnabled = false,
        curApptsCount;

      if (config.geo_location_enable == 1) {
        apptBook.googleAPI.enable();
        geoLocEnabled = true;
      }

      if (config.display_sessions_price == 1) {
        legalCopy.show();
      } else {
        legalCopy.hide();
      }

      function openOverlay(apptId) {
        $bod.prepend(overlay);
        overlay.css('display', 'block');
        overlayConf.css('display', 'block');
        overlayCanc.css('display', 'none');

        // yesBtn.attr('href', '/cancel-appointment?token=' + token + '&appointment_id=' + apptId);
        yesBtn.off('click keydown').on('click keydown', function (e) {
          var keycode = site.getKeycode(e);

          if (keycode === 13 || keycode === 1) {
            e.preventDefault();
            cancelAppointment(apptId, onCanceled);
          }
        });

        closeBtn.off('click').click(function (e) {
          e.preventDefault();
          closeOverlay();
        });

        noBtn.off('click keydown').on('click keydown', function (e) {
          var keycode = site.getKeycode(e);

          if (keycode === 13 || keycode === 1) {
            e.preventDefault();
            closeOverlay();
          }
        });
      }

      function closeOverlay() {
        overlay.remove();
      }

      function cancelAppointment(id, callback, errorCallback) {
        var url = 'https://' + window.location.hostname + '/_abapi/api/v1/appointments/' + id,
          params = {
            token: token,
            _method: 'DELETE'
          };

        $.ajax({
          url: url,
          type: 'POST',
          data: params,
          success: function (r) {
            if (typeof callback === 'function') {
              // var resp = JSON.parse(r);
              callback(r);
            }
          },

          error: function (err) {
            // console.log('Error: ' + err.status);
          }
        });
      }

      function formatPhone(raw) {
        var formatted = raw;

        if (!oab_phone_inline && raw.match(/\d{10}/)) {
          formatted = raw.substr(0, 3) + '-' + raw.substr(3, 3) + '-' + raw.substr(6, 4);
        }

        return formatted;
      }

      function onCanceled(r) {
        var m,
          d,
          y,
          h1,
          h2,
          mi,
          hSuffix1,
          hSuffix2,
          apptDayStr,
          apptHrStr,
          apptTimeStr,
          locString,
          out,
          totalDuration = 0,
          p = overlayCanc.find('p').empty(),
          dateFormat = $('#account-my-appointments').attr('data-date-format'),
          timeFormat = $('#account-my-appointments').attr('data-time-format'),
          apptId = r.id,
          servs = r.services,
          date = apptBook.myAppts.convertTimeString(r.start_time),
          dateEnd = new Date(),
          counter = r.counter,
          span = $('<span></span>'),
          isVirtual = r.counter.calendars[0].virtual === '1';

        overlayConf.css('display', 'none');
        overlayCanc.css('display', 'block');

        for (var i = 0, len = servs.length; i < len; i += 1) {
          var serv = servs[i];

          totalDuration += parseInt(serv.total_duration);
          out = span.clone().html(serv.name + ' <br/> ' + serv.total_duration + minLabel);
          p.append(out);
        }

        dateEnd.setTime(date.getTime() + parseInt(totalDuration) * 60000);

        m = months[date.getMonth()];
        d = date.getDate();
        y = date.getFullYear();

        h1 = date.getHours();
        mi = date.getMinutes() > 0 ? ':' + date.getMinutes() : ':00';

        if (!oab_time_format_24h) {
          hSuffix1 = h1 < 12 ? 'AM' : 'PM';
          h1 = ((h1 + 11) % 12) + 1 + mi + hSuffix1;
        } else {
          h1 = h1 + mi;
        }

        if (dateFormat === 'yyyymmdd') {
          apptDayStr = y + oab_year_suffix + ' ' + m + oab_month_suffix + ' ' + d + oab_day_suffix;
        } else if (dateFormat === 'ddmm') {
          if (oab_date_format_with_dot) {
            apptDayStr = d + '. ' + m + ' ' + y + ',';
          } else {
            apptDayStr = d + ' ' + m + ' ' + y;
          }
        } else {
          apptDayStr = m + ' ' + d + ', ' + y;
        }

        apptHrStr = h1;

        apptTimeStr = apptDayStr + ' ' + apptHrStr;

        out = span.clone().html(apptTimeStr);
        p.append(out);

        if (!isVirtual) {
          locString = counter.town + '<br/>' + counter.name + '<br/>' + counter.address1 + '<br/>';
          locString += counter.city ? counter.city + ' ' : '';
          locString +=
            (counter.state ? counter.state.short_name + ' ' : '') +
            (!counter.state && counter.county ? counter.county + ' ' : '');
          locString += counter.postcode ? counter.postcode : '';
          locString += counter.phone ? '<br/>' + formatPhone(counter.phone) : '';

          out = span.clone().html(locString);
          p.append(out);
        }

        $('#apptId_' + apptId).remove();

        curApptsCount -= 1;
        if (curApptsCount <= 0) {
          curAppts.remove();
          apptCont.prepend(noAppts);
        }
      }

      /* functions for building appointments*/

      function getAuthToken(callback) {
        generic.jsonrpc.fetch({
          method: 'appointmentbooking.getauthtoken',
          onSuccess: function (rpc) {
            token = rpc.getValue().auth_token;
            if (typeof callback === 'function') {
              callback(token);
            }
          },
          onError: function (rpc) {
            // console.log("Error getting authorization token");
          }
        });
      }

      function getCounters() {
        var url = 'https://' + window.location.hostname + '/_abapi/api/v1/counters',
          params = {
            token: token
          };

        $.ajax({
          url: url,
          type: 'GET',
          data: params,
          success: function (r) {
            if (!r || !r.length) {
              viewMakeupLessons.remove();
              suppressLinks = true;
            } else {
              apptBook.geoLoc.getCountersGeoLoc(r);
            }
          },

          error: function (err) {
            // console.log('Error: ' + err.status);
            /* var r = JSON.parse(err.responseText);
               if (typeof errorCallback === 'function') {
               errorCallback(r);
               }*/
            viewMakeupLessons.remove();
            suppressLinks = true;
          }
        });
      }

      function getAppointments(callback, errorCallback) {
        var url = 'https://' + window.location.hostname + '/_abapi/api/v1/appointments',
          params = {
            token: token
          };

        $.ajax({
          url: url,
          type: 'GET',
          data: params,
          success: function (r) {
            if (typeof callback === 'function') {
              // var resp = JSON.parse(r);
              callback(r);
            }
          },

          error: function (err) {
            // console.log('Error: ' + err.status);
            /* var r = JSON.parse(err.responseText);
              if (typeof errorCallback === 'function') {
                errorCallback(r);
              }*/
            buildNoAppts();
          }
        });
      }

      function buildCurrentServices(node, data) {
        var myData,
          mySNTmpl,
          mySDTmpl,
          myNode,
          mySName,
          mySTime,
          mySPrice,
          $serviceCont,
          servicesName,
          durationsPrices,
          servicesName,
          servicesDetails,
          me = this;

        totalDuration = 0;

        $serviceCont = node.find('.js-service');

        for (var i = 0, len = data.length; i < len; i += 1) {
          myData = data[i];

          $sContainer = $serviceCont.clone();
          mySNTmpl = $sContainer.find('.js-service-name');
          mySDTmpl = $sContainer.find('.js-service-details');

          mySTime = myData.total_duration;
          mySPrice = parseInt(myData.price);
          totalDuration += parseInt(mySTime);

          if (config.display_sessions_price === 1 && parseInt(mySPrice, 10) > 0) {
            mySName =
              myData.name +
              ' <span class="price">(' +
              curSymbol +
              parseInt(mySPrice, 10) +
              ')*<span>';
          } else {
            mySName = myData.name;
          }

          mySNTmpl.html(mySName);
          mySDTmpl.html(mySTime + ' ' + minLabel + ' ' + separator + ' ' + curSymbol + mySPrice);
          node.append($sContainer);
        }

        node.find('.js-service').first().remove();
      }

      function buildServices(node, data) {
        var myData,
          mySTmpl,
          mySNTmpl,
          myNode,
          mySName,
          mySTime,
          mySPrice,
          me = this;

        serviceData = data.services;
        counterData = data.counter;

        mySTmpl = node.find('.js-service');

        totalDuration = 0;

        for (var i = 0, len = serviceData.length; i < len; i += 1) {
          var sData = serviceData[i];

          myNode = mySTmpl.clone();
          mySNTmpl = myNode.find('.js-service-name');
          mySLTmpl = myNode.find('.js-service-location');
          mySTime = sData.total_duration;
          mySPrice = sData.price;
          myCName = counterData.name;
          totalDuration += parseInt(mySTime);

          if (config.display_sessions_price == 1 && parseInt(mySPrice) > 0) {
            mySName =
              sData.name +
              ' <span class="price">(' +
              curSymbol +
              parseInt(mySPrice, 10) +
              ')*</span>';
          } else {
            mySName = sData.name;
          }

          if (mySNTmpl.length) {
            mySNTmpl.html(mySName);
            mySLTmpl.html(myCName);
          } else {
            if (i == 0) {
              myNode.html(mySName);
            } else {
              myNode.html(' ' + separator + ' ' + mySName);
            }
          }
          var linebreak = document.createElement('P');

          mySTmpl.append(sData.name);
          mySTmpl.append(linebreak);
        }
        mySTmpl.find('.js-service-name').first().remove();
      }

      function buildVirtualLocation(node, meetingLink) {
        var apptHyperlink = node.find('.virtual-appt-link');

        if (meetingLink) {
          apptHyperlink.attr('href', meetingLink).text(meetingLink);
        }
      }

      function buildLocation(node, data) {
        var tpStr = '',
          googleStr = 'https://www.google.com/maps?daddr=',
          name = data.name,
          addr1 = data.address1,
          addr2 = data.address2,
          town = data.town,
          postCode = oab_postcode_override
            ? data.postcode.replace(/(\d{3})(\d{4})/u, '$1-$2')
            : data.postcode,
          phone = oab_phone_override
            ? data.phone.replace(/(\d{2})(\d{4})(\d{4}|\d{5})/u, '$1-$2-$3')
            : data.phone,
          state = data.state,
          county = data.county,
          email = data.email,
          nameNode = node.find('.location-name'),
          addrNode = node.find('.location-address'),
          addr2Node = node.find('.location-address2'),
          townPostNode = node.find('.location-town-postcode'),
          stateNode = node.find('.location-state'),
          phoneNode = node.find('.location-phone'),
          getDir = node.find('.location-direction-links');

        if (name) {
          nameNode.html(name);
          googleStr += name;
        } else {
          nameNode.hide();
        }

        if (addr1) {
          addrNode.html(addr1);
          googleStr += '+' + addr1;
        } else {
          addrNode.hide();
        }

        if (addr2) {
          addr2Node.html(addr2);
          googleStr += '+' + addr2;
        } else {
          addr2Node.hide();
        }

        if (town) {
          tpStr += town;
          townPostNode.html(town);
          googleStr += '+' + town;
        }

        if (state) {
          tpStr += ', ' + state.short_name;
          stateNode.html(state.short_name);
          googleStr += '+' + state.short_name;
        }

        if (county) {
          tpStr += ', ' + county;
          stateNode.html(county);
          googleStr += '+' + county;
        }

        if (postCode) {
          tpStr += tpStr === '' ? postCode : ', ' + postCode;
          googleStr += '+' + postCode;
        }

        if (tpStr === '') {
          townPostNode.hide();
        } else {
          townPostNode.html(tpStr);
        }

        if (phone) {
          if (phoneFormat == 'no-format') {
            // Do not modify the format of the phone number
          } else {
            // Default format
            phone = formatPhone(phone);
          }
          phoneNode.html(phone);
          if (typeof phoneNode.attr('href') !== 'undefined') {
            phoneNode.attr('href', 'tel:' + phone);
          }
        } else {
          phoneNode.hide();
        }

        getDir.attr('href', googleStr);
      }

      function buildDateTime(node, data, virtual) {
        var m,
          d,
          y,
          h1,
          h2,
          mi,
          hSuffix1,
          hSuffix2,
          apptDayStr,
          apptHrStr,
          apptStartDate = data.startDate,
          apptEndDate = new Date(apptStartDate.getTime()),
          dateNode = node.find('.date-time'),
          dateDay = dateNode.find('.date-time-day'),
          dateHours = dateNode.find('.date-time-hours'),
          dateDuration = node.find('.date-time-duration'),
          timeFormat = $('#account-my-appointments').attr('data-time-format'),
          dateFormat = $('#account-my-appointments').attr('data-date-format'),
          calContainer = node.find('.appt-date-cal'),
          isVirtual = virtual,
          calLocation;

        if (calContainer.length) {
          var typeClass = isVirtual ? '.virtual' : '.physical';
          var addCalLink = calContainer.find('.add-cal-link');
          var calLinks = calContainer.find('.date-time-link');
          var addCalTitle = calContainer.find('.add-cal-title').html() || '';
          var addCalDesc = calContainer.find('.add-cal-desc' + typeClass).html() || '';
          var addr1 = data.counter.address1 || '';
          var addr2 = data.counter.address2 || '';
          var town = data.counter.town || '';
          var state = data.counter.state || '';
          var postcode = data.counter.postcode || '';
          var virtMeetingLink = data.virtual_meeting_link;

          if (isVirtual) {
            calLocation = virtMeetingLink;
          } else {
            calLocation = addr1 + ', ' + town + ', ' + state + ' ' + postcode;
          }
        }

        apptEndDate.setTime(apptEndDate.getTime() + parseInt(totalDuration) * 60000);

        m = months[apptStartDate.getMonth()];
        d = apptStartDate.getDate();
        y = apptStartDate.getFullYear();

        h2 = apptEndDate.getHours();
        mi = apptEndDate.getMinutes() > 0 ? ':' + apptEndDate.getMinutes() : ':00';
        if (timeFormat == '12h') {
          hSuffix1 = h2 < 12 ? 'AM' : 'PM';
          h2 = ((h2 + 11) % 12) + 1 + mi + hSuffix1;
        } else {
          h2 = h2 + mi;
        }
        h1 = apptStartDate.getHours();
        mi = apptStartDate.getMinutes() > 0 ? ':' + apptStartDate.getMinutes() : ':00';
        hSuffix2 = h1 < 12 ? 'AM' : 'PM';
        hSuffix2 = hSuffix1 != hSuffix2 ? hSuffix2 : '';
        if (timeFormat == '12h') {
          h1 = ((h1 + 11) % 12) + 1 + mi + hSuffix2;
        } else {
          h1 = h1 + mi;
        }

        if (dateFormat === 'yyyymmdd') {
          apptDayStr = y + oab_year_suffix + ' ' + m + oab_month_suffix + ' ' + d + oab_day_suffix;
        } else if (dateFormat === 'ddmm') {
          if (oab_date_format_with_dot) {
            apptDayStr = d + '. ' + m + ' ' + y;
          } else {
            apptDayStr = d + ' ' + m + ' ' + y;
          }
        } else {
          apptDayStr = m + ' ' + d + ', ' + y;
        }

        apptHrStr = hSuffix1 ? h1 + ' ' + hSuffix1 : h1;
        apptDur = 0;
        // Appointment duration here is the total duration of the services in the appointment WITHOUT setup/takedown time.
        // We don't use the data.duration because that includes the setup and takedown time, which is not something
        // the customer should be seeing
        for (var i = 0; i < data.services.length; i++) {
          apptDur += parseInt(data.services[i].total_duration);
        }
        apptDur = apptDur + ' ' + minLabel;

        dateDay.text(apptDayStr);
        dateHours.text(apptHrStr);
        dateDuration.text(apptDur);

        if (calContainer.length) {
          me.myCalendar = createCalendar({
            data: {
              device_mobile: site.client.isMobile,
              title: addCalTitle, // Event title
              start: apptStartDate, // Event start date
              duration: totalDuration, // Event duration (IN MINUTES)
              end: apptEndDate, // You can also choose to set an end time. If an end time is set, this will take precedence over duration
              address: calLocation,
              description: addCalDesc
            }
          });

          calLinks.each(function () {
            var $this = $(this);
            var calID = $(this).attr('data-cal'),
              data = $.grep(me.myCalendar, function (el, i) {
                if (el.calId.toLowerCase() === calID) {
                  return el.calHref;
                }
              });
            var dataUri = data[0].calHref;

            createDownloadLink($this, dataUri, calID, 'calendar.ics');

            $this.on('click', function () {
              var calLinksCont = $(this).parents('.cals-container');

              calLinksCont.toggleClass('expanded');
            });

            function createDownloadLink(anchorSelector, dataUri, calID, fileName) {
              var dateUriIE = '';
              var blobObject = null;

              if (window.navigator.msSaveOrOpenBlob && calID !== 'google') {
                dateUriIE = dataUri.split(',')[1];
                dateUriIE = decodeURIComponent(dateUriIE);
                var fileData = [dateUriIE];

                blobObject = new Blob(fileData);
                $(anchorSelector).click(function (e) {
                  e.preventDefault();
                  window.navigator.msSaveOrOpenBlob(blobObject, fileName);
                });
              } else {
                $(anchorSelector).attr('href', dataUri);
              }
            }
          });

          addCalLink.on('click keydown', function (e) {
            var keycode = site.getKeycode(e);

            if (keycode === 13 || keycode === 1) {
              var calLinksCont = $(this).parent().find('.cals-container');

              calLinksCont.toggleClass('expanded');
            }
          });
        }
      }

      function buildArtistName(node, data) {
        var aName = data.public_name,
          aNameNode = node.find('.artist-name');

        aNameNode.html(aName);
      }

      function buildView(node, apptId) {
        var viewBtn = node.find('.js-service-view-link').off('click');

        if (!site.client.isMobile) {
          viewBtn.each(function () {
            $(this).addClass('disabled').hide();
          });
        } else {
          viewBtn.each(function () {
            var btn = $(this),
              closeH,
              openH,
              container = btn.closest('.appointment-container');

            dateTime = container.find('.date-time');

            closeH = dateTime.outerHeight(true);
            openH = container.height();
            container.height(closeH);
            container.addClass('js-mobile-hidden');

            btn.on('click', function (e) {
              e.preventDefault();
              var $this = $(this);

              if ($this.hasClass('disabled')) {
                return;
              }

              $this.addClass('disabled');

              container.toggleClass('js-mobile-hidden');
              if (container.hasClass('js-mobile-hidden')) {
                container.animate({ height: closeH + 'px' }, 700, function () {
                  $this.removeClass('disabled');
                });
              } else {
                container.animate({ height: openH + 'px' }, 700, function () {
                  $this.removeClass('disabled');
                });
              }
            });
          });
        }
      }

      function buildNoAppts() {
        apptCont.empty();
        apptCont.append(noAppts);
        if (suppressLinks) {
          noAppts.find('.button').remove();
        }
      }

      function buildNoSignin() {
        apptCont.append(noSignin);

        var noSignInContainer = container.find('#appt-book-my-appointments-no-signin'),
          header = noSignInContainer.find('.appt-book-content-header'),
          signInHeader = header.find('.sign-in-title'),
          signUpHeader = header.find('.sign-up-title'),
          errorContainer = noSignInContainer.find('#appt-book-my-appts-error-messages').hide(),
          errorMessages = errorContainer.find('.error-message'),
          // Sign In Fields
          signInContainer = noSignInContainer.find('.sign-in-container'),
          signInLink = signInContainer.find('#my-appts-sign-up-link').off('click'),
          signInEmail = signInContainer.find('#my-appts-login-email'),
          signInPw = signInContainer.find('#my-appts-login-password'),
          signInBtn = signInContainer.find('#my-appts-login-submit').off('click'),
          forgotPasswordLink = signInContainer.find('.js-forgot-password').off('click'),
          hiddenForm = signInContainer.find('.js-signin-hidden-form'),
          // Sign Up Fields
          signUpContainer = noSignInContainer.find('.registration-container'),
          signUpLink = signUpContainer.find('#my-appts-sign-in-link').off('click'),
          fNameInput = signUpContainer.find('.registration-first-name'),
          lNameInput = signUpContainer.find('.registration-last-name'),
          emailInput = signUpContainer.find('.registration-email'),
          phoneInput = signUpContainer.find('.registration-mobile'),
          checkboxInput = signUpContainer.find('input[type=checkbox]'),
          signUpPw = signUpContainer.find('.registration__password'),
          signUpEmailInput = signUpContainer.find('.registration__email-list').find('input'),
          signUpSMSInput = signUpContainer.find('.registration__sms-list').find('input'),
          signUpPrivacyInput = signUpContainer.find('.registration__privacy-list').find('input'),
          signUpPrivacyContainer = signUpContainer.find('.registration__privacy_policy-container'),
          signUpBtn = signUpContainer.find('#my-appts-registration-submit').off('click');

        signInContainer.show();
        signInHeader.show();
        signUpContainer.hide();
        signUpHeader.hide();

        if (site.facebook) {
          site.facebook.init();
        }

        if (validate_password_enabled && Drupal.behaviors.validatePassword) {
          Drupal.behaviors.validatePassword.attach();
        }

        // checkboxInput.picker();

        signUpPrivacyContainer.find('label a').on('tap click', function (e, data) {
          e.stopPropagation();
          e.preventDefault();
          window.open($(this).attr('href'), $(this).attr('target'));

          return false;
        });

        signInLink.on('click', function (e) {
          e.preventDefault();
          signInContainer.hide();
          signInHeader.hide();
          signUpContainer.show();
          signUpHeader.show();
          errorMessages.css('display', 'none');
          signInContainer.find('input').removeClass('error');
        });
        signInBtn.on('click', function (e) {
          e.preventDefault();
          var $this = $(this),
            isEmptyField = 0,
            params = [];

          if ($this.hasClass('disabled')) {
            return;
          }

          $this.addClass('disabled');

          params.push({
            _SUBMIT: 'signin',
            EMAIL_ADDRESS: signInEmail.val(),
            PASSWORD: signInPw.val()
          });

          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: JSON.stringify(params),
            onSuccess: function (jsonRpcResponse) {
              signInBtn.removeClass('disabled');
              onUpdate();
            },
            onFailure: function (jsonRpcResponse) {
              var errObjs = jsonRpcResponse.getMessages();

              errorContainer.css('display', 'block');
              errorMessages.css('display', 'none');
              signInContainer.find('input').removeClass('error');

              for (var i = 0; i < errObjs.length; i += 1) {
                var myErr = errObjs[i];

                if (myErr && myErr.key) {
                  if (
                    myErr.key === 'required.password.signin' ||
                    myErr.key === 'required.password.signin.app'
                  ) {
                    signInPw.addClass('error');
                    errorMessages.filter('#error-signin-password').css('display', 'block');
                  }

                  if (
                    myErr.key === 'invalid.password.signin' ||
                    myErr.key === 'invalid.password.signin.app'
                  ) {
                    signInPw.addClass('error');
                    errorMessages.filter('#error-signin-invalid-password').css('display', 'block');
                  }

                  if (
                    myErr.key === 'required_or.email_address.device_id.required_or.signin' ||
                    myErr.key === 'required_or.email_address.device_id.required_or.signin.app'
                  ) {
                    signInEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').css('display', 'block');
                  }

                  if (
                    myErr.key === 'required.email_address.signin' ||
                    myErr.key === 'required.email_address.signin.app'
                  ) {
                    signInEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').css('display', 'block');
                  }

                  if (
                    myErr.key === 'invalid.email_address.signin' ||
                    myErr.key === 'invalid.email_address.signin.app'
                  ) {
                    signInEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').css('display', 'block');
                  }

                  if (
                    myErr.key === 'no_account..signin' ||
                    myErr.key === 'no_account..signin.app'
                  ) {
                    signInEmail.addClass('error');
                    signInPw.addClass('error');
                    errorMessages.filter('#error-signin-no-account').css('display', 'block');
                  }
                  if (myErr.key === 'account_lockout' || myErr.key === 'account_lockout.app') {
                    errorMessages.filter('#error-signin-account-lockout').css('display', 'block');
                  }
                }
              }

              $this.removeClass('disabled');
            }
          });
        });

        forgotPasswordLink.on('click', function (e) {
          // Reset the Error messages
          errorMessages.css('display', 'none');
          errorContainer.css('display', 'none');
          signInContainer.find('input, textarea, .label, .picker-handle').removeClass('error');

          email = signInEmail.val(); // Take the Signin Email field value.
          actionURL = forgotPasswordLink.attr('href');

          if (!hiddenForm || !actionURL) {
            return null;
          }
          if (!email) {
            e.preventDefault();
            errorContainer.css('display', 'block');
            signInEmail.addClass('error');
            errorMessages.filter('#error-signin-email').css('display', 'block');

            return null;
          }

          var hiddenEmailNode = hiddenForm.find('.js-hidden-email');

          hiddenEmailNode.val(email);

          var hiddenReturnNode = hiddenForm.find('.js-hidden-return'),
            returnURL = window.location.pathname;

          hiddenReturnNode.val(returnURL);

          hiddenForm.submit();
        });

        signUpLink.on('click', function (e) {
          e.preventDefault();
          signInContainer.show();
          signInHeader.show();
          signUpContainer.hide();
          signUpHeader.hide();
          errorMessages.css('display', 'none');
          signUpContainer.find('input').removeClass('error');
          signUpPrivacyContainer.find('span.label').removeClass('error');
        });

        signUpBtn.on('click', function (e) {
          e.preventDefault();
          var $this = $(this),
            fName = fNameInput.val(),
            lName = lNameInput.val(),
            email = emailInput.val(),
            phone = phoneInput.val(),
            pass = signUpPw.val(),
            signUpEmail = signUpEmailInput.is(':checked') ? signUpEmailInput.val() : 0,
            signUpSMS = signUpSMSInput.is(':checked') ? signUpSMSInput.val() : 0,
            signUpPrivacy = signUpPrivacyInput.is(':checked') ? signUpPrivacyInput.val() : '',
            signUpEmailObj = {},
            params = [];

          e.preventDefault();

          if ($this.hasClass('disabled')) {
            return;
          }

          $this.addClass('disabled');

          signUpEmailObj._SUBMIT = 'registration_short';
          signUpEmailObj.EMAIL_ADDRESS = emailInput.val();
          signUpEmailObj.PC_EMAIL_ADDRESS = emailInput.val();
          signUpEmailObj.PC_EMAIL_ADDRESS2 = emailInput.val();
          signUpEmailObj.PASSWORD = signUpPw.val();
          signUpEmailObj.PASSWORD2 = signUpPw.val();
          signUpEmailObj.FIRST_NAME = fNameInput.val();
          signUpEmailObj.LAST_NAME = lNameInput.val();
          signUpEmailObj.ACCEPTED_PRIVACY_POLICY = signUpPrivacy;
          signUpEmailObj.CAN_ADD_ADDRESS = 0;
          if (signUpEmail) {
            signUpEmailObj.PC_EMAIL_PROMOTIONS = 1;
          }

          if (signUpSMS) {
            signUpEmailObj._SECONDARY_SUBMIT = 'sms';
            signUpEmailObj.MOBILE_PHONE = phoneInput.val();
            signUpEmailObj.SMS_PROMOTIONS = 1;
          } else {
            signUpEmailObj._SECONDARY_SUBMIT = 'sms';
            signUpEmailObj.SMS_PROMOTIONS = 0;
          }

          params.push(signUpEmailObj);

          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: JSON.stringify(params),
            onSuccess: function (jsonRpcResponse) {
              signUpEmailObj._SUBMIT = 'registration';
              params = [];
              params.push(signUpEmailObj);
              generic.jsonrpc.fetch({
                method: 'rpc.form',
                params: JSON.stringify(params),
                onSuccess: function (jsonRpcResponse) {
                  signUpBtn.removeClass('disabled');
                  onUpdate();
                },
                onFailure: function (jsonRpcResponse) {
                  signUpBtn.removeClass('disabled');
                  onUpdate();
                }
              });
            },
            onFailure: function (jsonRpcResponse) {
              var errObjs = jsonRpcResponse.getMessages();
              var errorMessagePasswordId = '';

              errorContainer.css('display', 'block');
              errorMessages.css('display', 'none');
              signUpContainer.find('input').removeClass('error');
              signUpPrivacyContainer.find('span.label').removeClass('error');

              for (var i = 0; i < errObjs.length; i += 1) {
                var myErr = errObjs[i];

                if (myErr && myErr.key) {
                  if (
                    (myErr.key === 'required.password.registration_short' ||
                      myErr.key === 'required.password.registration_short.app') &&
                    errorMessagePasswordId !== 'error-registration-min-max-password'
                  ) {
                    signUpPw.addClass('error');
                    errorMessagePasswordId = 'error-registration-password';
                    errorMessages.filter('#error-registration-password').css('display', 'block');
                    errorMessages
                      .filter('#error-registration-min-max-password')
                      .css('display', 'none');
                  }

                  if (
                    (myErr.key === 'invalid.password.registration_short' ||
                      myErr.key === 'invalid.password.registration_short.app') &&
                    errorMessagePasswordId !== 'error-registration-min-max-password'
                  ) {
                    signUpPw.addClass('error');
                    errorMessagePasswordId = 'error-registration-invalid-password';
                    errorMessages
                      .filter('#error-registration-invalid-password')
                      .css('display', 'block');
                    errorMessages.filter('#error-registration-password').css('display', 'none');
                    errorMessages
                      .filter('#error-registration-min-max-password')
                      .css('display', 'none');
                  }

                  if (
                    myErr.key === 'min_max.password.registration_short' ||
                    myErr.key === 'format.password.registration_short' ||
                    myErr.key === 'min_max.password.registration_short.app'
                  ) {
                    signUpPw.addClass('error');
                    errorMessagePasswordId = 'error-registration-min-max-password';
                    errorMessages
                      .filter('#error-registration-min-max-password')
                      .css('display', 'block');
                    errorMessages.filter('#error-registration-password').css('display', 'none');
                    errorMessages
                      .filter('#error-registration-invalid-password')
                      .css('display', 'none');
                  }

                  if (
                    myErr.key === 'required.pc_email_address.registration_short' ||
                    myErr.key === 'invalid.pc_email_address.registration_short' ||
                    myErr.key === 'required.pc_email_address.registration_short.app' ||
                    myErr.key === 'invalid.pc_email_address.registration_short.app'
                  ) {
                    emailInput.addClass('error');
                    errorMessages.filter('#error-registration-email').css('display', 'block');
                  }
                  if (
                    myErr.key === 'required.accepted_privacy_policy.registration_short' ||
                    myErr.key === 'required.accepted_privacy_policy.registration_short.app'
                  ) {
                    signUpPrivacyInput.addClass('error');
                    signUpPrivacyContainer.find('span.label').addClass('error');
                    errorMessages.filter('#error-signup-privacy-invalid').css('display', 'block');
                  }

                  if (
                    myErr.key === 'invalid.accepted_privacy_policy.registration_short' ||
                    myErr.key === 'invalid.accepted_privacy_policy.registration_short.app'
                  ) {
                    emailInput.addClass('error');
                    errorMessages.filter('#error-registration-email').css('display', 'block');
                    errorMessages.filter('#' + errorMessagePasswordId).css('display', 'block');
                  }

                  if (myErr.key === 'account_exists' || myErr.key === 'account_exists.app') {
                    emailInput.addClass('error');
                    errorMessages
                      .filter('#error-registration-account-exist')
                      .css('display', 'block');
                  }
                }
              }

              $this.removeClass('disabled');
            }
          });
        });

        $('.adpl--processed').focusout(function () {
          var $this = $(this);

          if ($this.val().length > 1) {
            $this.removeClass('adpl__mode-placeholder').addClass('adpl__mode-label');
          } else {
            $this.removeClass('adpl__mode-label').addClass('adpl__mode-placeholder');
          }
        });
      }

      function buildCurrent() {
        var len = curApptData.length;

        if (!len) {
          apptCont.append(noAppts);

          return;
        }
        apptCont.append(curAppts);
        curApptsCount = len;

        for (var i = 0; i < len; i += 1) {
          var cAObj = curApptData[i],
            isVirtual = cAObj.counter.calendars[0].virtual === '1' ? 1 : 0,
            apptId = cAObj.id,
            myAptNode = curApptTmpl.clone(),
            lesNode = myAptNode.find('.js-your-services'),
            locNode = isVirtual
              ? myAptNode.find('.location.virtual_oab_content')
              : myAptNode.find('.location.physical_oab_content'),
            dateNode = myAptNode.find('.date-time'),
            artNode = myAptNode.find('.artist'),
            changeBtn = myAptNode.find('.change-appt-btn'),
            cancelBtn = myAptNode.find('.cancel-appt-btn'),
            href = changeBtn.attr('href');

          myAptNode.attr('id', 'apptId_' + apptId);
          locNode.removeClass('hidden');
          buildCurrentServices(lesNode, cAObj.services);
          if (isVirtual) {
            buildVirtualLocation(locNode, cAObj.virtual_meeting_link);
          } else {
            buildLocation(locNode, cAObj.counter);
          }
          buildDateTime(myAptNode, cAObj, isVirtual);
          buildArtistName(artNode, cAObj.calendar);

          if (isVirtual) {
            changeBtn.remove();
          }
          if (suppressLinks) {
            changeBtn.remove();
            cancelBtn.remove();
          } else {
            changeBtn.attr('href', href + '?appointment_id=' + apptId);
            changeBtn.click(function (e) {});

            cancelBtn.attr('data-appt-id', apptId);

            cancelBtn.click(function (e) {
              var myId,
                $this = $(this);

              e.preventDefault();
              var popup = $('#appt-book-my-appointments-overlay');

              myId = $this.attr('data-appt-id');

              openOverlay(myId);
              $('.js-overlay_container').focus();
              site.restrict_navigation($('.js-overlay_container'));
            });
          }

          curApptTmplWrppr.append(myAptNode);
        }
      }

      function buildPast() {
        var openH,
          closeH,
          len = pastApptData.length;

        if (!len) {
          return;
        }
        apptCont.append(pastAppts);

        for (var i = 0; i < len; i += 1) {
          var pAObj = pastApptData[i],
            isVirtual = pAObj.counter.calendars[0].virtual === '1' ? 1 : 0,
            apptId = pAObj.id,
            myAptNode = pastApptTmpl.clone(),
            lesNode = myAptNode.find('.your-services'),
            locNode = isVirtual
              ? myAptNode.find('.location.virtual_oab_content')
              : myAptNode.find('.location.physical_oab_content'),
            dateNode = myAptNode.find('.date-time'),
            artNode = myAptNode.find('.artist');

          myAptNode.attr('id', 'apptId_' + apptId);
          if (!isVirtual) {
            buildLocation(locNode, pAObj.counter);
          }
          locNode.removeClass('hidden');
          buildDateTime(dateNode, pAObj, isVirtual);
          buildArtistName(artNode, pAObj.calendar);
          buildServices(lesNode, pAObj);

          pastApptTmplWrppr.append(myAptNode);
        }

        buildView(pastAppts, apptId);
      }

      function onApptsData(aData) {
        var now = new Date().getTime(),
          len = aData.length;

        if (!aData.length) {
          buildNoAppts();

          return;
        }

        curApptData = [];
        pastApptData = [];

        for (var i = 0; i < len; i += 1) {
          var aDObj = aData[i],
            aDate = me.convertTimeString(aDObj.start_time);

          aDObj.startDate = aDate;
          aDObj.counter = apptBook.geoLoc.mergeGeoLocWithCounters(aDObj.counter)[0];

          if (aDate.getTime() < now) {
            pastApptData.push(aDObj);
          } else {
            curApptData.push(aDObj);
          }
        }

        buildCurrent();
        buildPast();

        // this triger is also need for portrait view in IPAD and for Responsive mode
        $(document).trigger('collapsibleBlock.refresh');
      }

      function onUpdate() {
        apptCont.empty();
        generic.jsonrpc.fetch({
          method: 'user.json',
          onSuccess: function (jsonRpcResponse) {
            userData = jsonRpcResponse.getValue();
            processUpdate();
          },
          onFailure: function (jsonRpcResponse) {
            processUpdate();
          }
        });

        function processUpdate() {
          if (userData && userData.signed_in) {
            isSignedIn = userData.signed_in;
          } else {
            isSignedIn =
              typeof site.userInfoCookie == 'undefined' ||
              _.isUndefined(site.userInfoCookie.getValue('signed_in')) ||
              _.isNull(site.userInfoCookie.getValue('signed_in')) ||
              site.userInfoCookie.getValue('signed_in') == '0'
                ? 0
                : site.userInfoCookie.getValue('signed_in');
          }
          if (isSignedIn) {
            // Kick everything off with a call to getAuthToken
            getAuthToken(function (t) {
              getCounters();

              if (geoLocEnabled) {
                $(document).on(
                  'geoloc_data',
                  $.proxy(function (e, data) {
                    getAppointments(onApptsData);
                  }, this)
                );
              } else {
                getAppointments(onApptsData);
              }
            });
          } else {
            buildNoSignin();
          }
        }
      }

      onUpdate();
    },

    convertTimeString: function (tString) {
      var split, dateArray, timeArray, y, m, d, hr, min, sec;

      split = tString.split(' ');
      dateArray = split[0].split('-');
      timeArray = split[1].split(':');

      y = parseInt(dateArray[0], 10);
      m = parseInt(dateArray[1], 10) - 1;
      d = parseInt(dateArray[2], 10);
      hr = parseInt(timeArray[0], 10);
      min = parseInt(timeArray[1], 10);
      sec = parseInt(timeArray[2], 10);

      return new Date(y, m, d, hr, min, sec);
    },

    adjustRowHeights: function ($nodes, limit) {
      var rowArray = $([]);

      for (var i = 0; i < $nodes.length; i++) {
        rowArray.push($nodes[i]);
        if (i % limit) {
          apptBook.equalHeights(rowArray);
          rowArray = $([]);
        }
      }
    }
  };

  Drupal.behaviors.ApptBookMyAppts = {
    attach: function (context) {
      if ($('#appointment-book-container').length) {
        apptBook.myAppts.init();
      }
    }
  };
})(jQuery);
